import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTravelSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#travel-search_svg__a)">
      <path
        fill="#263E6A"
        d="M20.757 12.723a.332.332 0 1 1-.584-.319 6.35 6.35 0 0 0-1.082-7.489 6.28 6.28 0 0 0-4.468-1.85 6.28 6.28 0 0 0-4.468 1.85 6.27 6.27 0 0 0-1.851 4.467c0 1.687.657 3.273 1.85 4.466 2.114 2.113 5.455 2.453 7.945.81a.333.333 0 0 1 .367.555 6.95 6.95 0 0 1-3.832 1.146 7 7 0 0 1-4.709-1.812l-6.957 6.956a.33.33 0 0 1-.47 0 .33.33 0 0 1 0-.47l6.957-6.955a6.93 6.93 0 0 1-1.816-4.696c0-1.865.726-3.618 2.045-4.937A6.94 6.94 0 0 1 14.623 2.4a6.94 6.94 0 0 1 4.938 2.045c2.176 2.175 2.668 5.58 1.196 8.278m-7.496 1.252a.332.332 0 1 0-.152.648 5.583 5.583 0 0 0 5.255-1.497 5.61 5.61 0 0 0 1.543-5.044.333.333 0 0 0-.653.127 4.95 4.95 0 0 1-1.36 4.446 4.93 4.93 0 0 1-4.633 1.32"
      />
    </g>
    <defs>
      <clipPath id="travel-search_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTravelSearch;
